<template>
  <div>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <i class="dot"></i> 기본정보
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">사업장명</div>
        <span v-if="isPrint" class="print-input"> {{form.inputA_1}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_1" :readonly="true"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">소속</div>
        <span v-if="isPrint" class="print-input"> {{form.inputA_6}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_6" :readonly="true"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">부서</div>
        <span v-if="isPrint" class="print-input"> {{form.inputA_2}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_2" :readonly="true"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성자</div>
        <span v-if="isPrint" class="print-input"> {{form.inputA_3}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_3" :readonly="true"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">직급</div>
        <span v-if="isPrint" class="print-input"> {{form.inputA_4}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_4" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성일</div>
        <span v-if="isPrint" class="print-input"> {{form.inputA_5}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputA_5" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row style="padding: 1rem 0;">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <i class="dot"></i> 관련내용
      </vs-col>
    </vs-row>
    <div class="col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">사고경위</div>
      <div v-if="isPrint" class="print-textarea"> {{form.inputB_1}} </div>
      <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_1" :readonly="board.readonly" placeholder="6하 원칙에 의거 상세히 기술"/>
    </div>
    <file-upload-module v-if="!isPrint" v-model="form.fileList" class="w-full" :isPrint="isPrint"/>
  </div>
  </template>

<script>
import DateSelector from '@/components/selector/DateSelector'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  name: 'Write',
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.writer.section
        this.form.inputA_3 = this.value && this.value.inputA_3 ? this.value.inputA_3 : this.board.writer.name
        this.form.inputA_6 = this.value && this.value.inputA_6 ? this.value.inputA_6 : this.board.writer.department
      }
    },
    value (value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        if (value[key]) {
          this.form[key] = value[key]
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_1
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      form: {
        inputA_1:'',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputB_1:'',
        fileList: []
      }
    }
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  components: {
    DateSelector,
    FileUploadModule
  }
}
</script>

  <style scoped>
    .label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
  }
  .grid {
    padding-top: 1rem;
  }
  </style>
